import { type BaseRowData } from '@adv-frontend/data-provider';
import { type AttributeOptions } from './lib/types';
import { type ExtendCellTemplateProps, type GridRow } from '../../lib/types';
import { CellAttributeValue } from './CellAttributeValue';

export const renderCellAttributeValue = <RowData extends BaseRowData = GridRow>(options: AttributeOptions<RowData>) =>
    function RenderCellAttributeValue(props: ExtendCellTemplateProps<RowData>) {
        return <CellAttributeValue<RowData> {...props} {...options} />;
    };
